import React, { useState } from "react";
import {
  Modal,
  Spin,
  Tabs,
  Form,
  Select,
  Table,
  Checkbox,
  notification,
} from "antd";
import Cookies from "js-cookie";
import Api from "../../../../services/ServiceApi";
import AssingJobMap from "../../../../ui/map/assign_job";

const { TabPane } = Tabs;
export default function AssignSub({
  ModalShow,
  setModalShow,
  jobDetail,
  dataSelect,
  dataTeam,
  workflowJob,
}) {
  const [empList, setempList] = useState([]);
  // const [teamList, setteamList] = useState([]);
  const [loading, setloading] = useState(false);
  const [statusSubmit, setstatusSubmit] = useState(false);
  const columns_employee = [
    {
      title: "Select",
      dataIndex: "",
      key: "",
      render: (item) => {
        return (
          <Checkbox
            onChange={(e) => {
              if (e.target.checked) {
                CheckAssign(item.employee_id, item.team_id, item.team_group_id);
              }
            }}
          ></Checkbox>
        );
      },
    },
    {
      title: "Emp Code",
      dataIndex: "emp_code",
      key: "emp_code",
    },
    {
      title: "Name",
      dataIndex: "emp_name",
      key: "emp_name",
    },
    {
      title: "Nick Name",
      dataIndex: "emp_nickname",
      key: "emp_nickname",
    },
    {
      title: "Skill",
      dataIndex: "ma_skill_name",
      key: "ma_skill_name",
    },
    {
      title: "Team Group Name",
      dataIndex: "team_group_name",
      key: "team_group_name",
      width: 100,
      render: (text) => <div></div>,
    },

    {
      title: "Status",
      dataIndex: "",
      key: "",
      render: (item) => (
        <span>
          {Number(item.is_active) === 1 ? (
            <span className="c-green">
              <span className="dot-active mr-2"></span>Active
            </span>
          ) : (
            <span className="c-red">
              <span className="dot-Inactive mr-2"></span>InActive
            </span>
          )}
        </span>
      ),
    },
    {
      title: "On Hand Job",
      dataIndex: "current_onhand_job",
      key: "current_onhand_job",
    },
  ];
  // const columns_team = [
  //   {
  //     title: "Select",
  //     dataIndex: "",
  //     key: "",
  //     render: (item) => {
  //       return (
  //         <Checkbox
  //           onChange={(e) => {
  //             if (e.target.checked) {
  //               CheckAssignTeam(item.team_id, item.team_group_id);
  //             }
  //           }}
  //         ></Checkbox>
  //       );
  //     },
  //   },
  //   {
  //     title: "Team Group Name",
  //     dataIndex: "team_group_name",
  //     key: "team_group_name",
  //   },
  //   {
  //     title: "Team Sub Name",
  //     dataIndex: "team_sub_name",
  //     key: "team_sub_name",
  //   },
  //   {
  //     title: "Name List",
  //     dataIndex: "emp_name",
  //     key: "emp_name",
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "",
  //     key: "",
  //     render: () => (
  //       <span className="c-green">
  //         <span className="dot-active mr-2"></span>Active
  //       </span>
  //     ),
  //   },
  //   {
  //     title: "On Hand Job",
  //     dataIndex: "current_onhand_job",
  //     key: "current_onhand_job",
  //   },
  // ];
  let setDatatosummit = [];
  function CheckAssign(employee_id, team_id, team_group_id) {
    workflowJob.map((data, index) => {
      if (data.from_main_process_id === 1 && data.next_main_action_id === 16) {
        let Mocktosend = {
          ...workflowJob[index],
          job_no: jobDetail.job_no,
          emp_code: employee_id,
          create_by: Cookies.get("username"),
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          job_progress_id: jobDetail.job_progress_id,
          project_id: Cookies.get("project_id"),
          flag_reassign: "assign",
          emp_or_team: "E",
          job_id: jobDetail.job_id,
          team_id: team_id,
          team_group_id: team_group_id,
        };
        setDatatosummit.push(Mocktosend);
      }
    });
  }
  function CheckAssignTeam(team_id, team_group_id) {
    workflowJob.map((data, index) => {
      if (data.from_main_process_id === 1 && data.next_main_action_id === 16) {
        let MockupsendTeam = {
          ...workflowJob[index],
          job_no: jobDetail.job_no,
          emp_code: "",
          create_by: Cookies.get("username"),
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          job_progress_id: jobDetail.job_progress_id,
          project_id: Cookies.get("project_id"),
          flag_reassign: "assign",
          emp_or_team: "T",
          job_id: jobDetail.job_id,
          team_id: team_id,
          team_group_id: team_group_id,
        };
        setDatatosummit.push(MockupsendTeam);
      }
    });
  }
  async function SendAssign() {
    setstatusSubmit(true);
    workflowJob.map((data, index) => {
      if (data.from_main_process_id === 1 && data.next_main_action_id === 16) {
        Api.post("update_job_ma_to_employee_V2", setDatatosummit).then(
          (res) => {
            if (res.data.result.code === "P") {
              setModalShow(false);
              notification.success({
                message: "Assign งานเรียบร้อยแล้ว",
                description: "ท่านสามารถตรวจสอบรายละเอียดงานได้ที่เมนูถัดไป",
                duration: 5,
                className: "font-thai-b fs-18",
              });
              setstatusSubmit(false);
              setDatatosummit = [];
            } else if (res.data.result.code === "F") {
              setModalShow(false);
              notification.error({
                message: "Error",
                description: res.data.result?.showText,
                duration: 5,
                className: "font-thai-b fs-18",
              });
              setstatusSubmit(false);
            }
          }
        );
      }
    });
    if (workflowJob?.length === 0) {
      notification.error({
        message: "ผิดพลาด",
        description: "คุณไม่มีสิทธ์ในการใช้งาน",
        duration: 5,
        className: "font-thai-b fs-18",
      });
      setstatusSubmit(false);
    }
  }
  async function OnChangeEmp(val) {
    setloading(true);
    Api.post("get_assign_job_ma_trs_mm", {
      company_id: Cookies.get("companyid"),
      select: "employee",
      skill_id: val,
      sql_where: null,
      team_id: null,
      subflag: "Y",
    })
      .then((res) => {
        if (res.data.result.code === "P") {
          setempList(res.data.data.result_list_ma_employee);
          setloading(false);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  // async function OnChangeTeam(val) {
  //   Api.post("get_assign_job_ma_trs_mm", {
  //     company_id: Cookies.get("companyid"),
  //     select: "team",
  //     skill_id: val,
  //     sql_where: null,
  //     team_id: null,
  //     subflag: "Y",
  //   })
  //     .then((res) => {
  //       if (res.data.result.code === "P") {
  //         setteamList(res.data.data.result_list_ma_team);
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }

  return (
    <>
      <Modal
        title={null}
        visible={ModalShow}
        centered
        footer={null}
        closable={false}
        className="custom-modal-map-large"
      >
        <div className="row">
          <div className="col-4">
            <AssingJobMap></AssingJobMap>
          </div>
          <div className="col-8">
            <div style={{ padding: "24px 24px 0 0 " }}>
              <Spin spinning={false}>
                <span className="font-mont-b fs-16 c-red text-uppercase">
                  Assign Job : {jobDetail.job_no} ***** Obsolete, Change to AssignJobComponent *****
                </span>
                <Tabs defaultActiveKey="1" style={{ background: "#fff" }}>
                  <TabPane tab="Employee" key="1">
                    <div className="row">
                      <div className="col">
                        <Form name="control-hooks">
                          <Form.Item
                            name="employee_skill"
                            label="Employee Skill"
                            rules={[{ required: true }]}
                          >
                            <Select
                              allowClear
                              style={{ border: "0px", width: "50%" }}
                              placeholder="Select a Employee Skill"
                              className="inputfile"
                              onChange={OnChangeEmp}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children === "" ||
                                option.children === null
                                  ? null
                                  : option.children
                                      .toLowerCase()
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {dataSelect.map((item, index) => (
                                <Select.Option
                                  value={item.ma_skill_id}
                                  key={index}
                                  obj={item}
                                  type_sc="emp_skill"
                                >
                                  {item.ma_skill_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form>
                      </div>
                    </div>
                    <Table
                      size="small"
                      loading={loading}
                      rowKey="employee_id"
                      rowSelection={""}
                      columns={columns_employee}
                      dataSource={empList ? empList : null}
                      style={{
                        whiteSpace: "nowrap",
                        lineHeight: "0.7 !important",
                      }}
                    />
                  </TabPane>
                  {/* <TabPane tab="Team" key="2">
                    <div className="row">
                      <div className="col-12" style={{ marginBottom: "-20px" }}>
                        <Form name="control-hooks">
                          <Form.Item
                            name="team_skill"
                            label="Team Skill"
                            rules={[{ required: true }]}
                          >
                            <Select
                              showSearch
                              style={{ border: "0px", width: "50%" }}
                              placeholder="Select a Team Skill"
                              className="inputfile"
                              onChange={OnChangeTeam}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children === "" ||
                                option.children === null
                                  ? null
                                  : option.children
                                      .toLowerCase()
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {dataTeam.map((item, index) => (
                                <Select.Option
                                  value={item.team_group_id}
                                  key={index}
                                  obj={item}
                                  type_sc="team_skill"
                                >
                                  {item.team_group_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Form>
                      </div>
                      <div
                        className="col-12 "
                        style={{ marginLeft: "67px" }}
                      ></div>
                    </div>
                    <Table
                      size="small"
                      rowKey="team_id"
                      rowSelection={""}
                      columns={columns_team}
                      dataSource={teamList ? teamList : null}
                      style={{
                        whiteSpace: "nowrap",
                        lineHeight: "0.7 !important",
                      }}
                    />
                  </TabPane> */}
                </Tabs>
                <div className="mt-4 text-center">
                  <button
                    type="reset"
                    onClick={() => setModalShow(false)}
                    className="btn btn-secondary"
                  >
                    Close
                  </button>
                  {statusSubmit ? (
                    <button className="btn btn-success" disabled>
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      onClick={() => SendAssign()}
                    >
                      Assign
                    </button>
                  )}
                </div>
              </Spin>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
